import { useTranslation } from "react-i18next";
import { Check, X } from "lucide-react";
import type { QuizResponseDetail } from "../types";

// Free-text answers (short_text/long_text/number) carry no options array, so
// there is nothing to mark right or wrong against — just show what was
// typed. Choice questions render every option, marking the teacher's pick(s)
// and the answer key together so a wrong answer is legible at a glance.
export function QuizAnswerReview({ quiz }: { quiz: QuizResponseDetail }) {
  const { t } = useTranslation();
  return (
    <div className="flex flex-col gap-3">
      {quiz.questions.map((question) => {
        const selected = Array.isArray(question.answer)
          ? question.answer.map(String)
          : question.answer == null
            ? []
            : [String(question.answer)];

        return (
          <div key={question.id} className="flex flex-col gap-1.5 rounded-lg bg-app-field p-3">
            <p className="text-sm font-medium text-app-ink">{question.text}</p>

            {question.options.length > 0 ? (
              <div className="flex flex-col gap-1">
                {question.options.map((option) => {
                  const picked = selected.includes(option.id);
                  const tone = option.is_correct
                    ? "text-success-text"
                    : picked
                      ? "text-danger"
                      : "text-app-copy";
                  return (
                    <span key={option.id} className={`flex items-center gap-1.5 text-sm ${tone}`}>
                      {option.is_correct ? (
                        <Check size={14} className="shrink-0" />
                      ) : picked ? (
                        <X size={14} className="shrink-0" />
                      ) : (
                        <span className="w-[14px] shrink-0" />
                      )}
                      {option.text}
                      {picked && !option.is_correct && (
                        <span className="text-xs text-app-muted">{t("yourAnswer")}</span>
                      )}
                    </span>
                  );
                })}
              </div>
            ) : (
              <p className="text-sm text-app-copy">
                {selected.length > 0 ? selected.join(", ") : t("noAnswerGiven")}
              </p>
            )}
          </div>
        );
      })}
    </div>
  );
}
